import { Box, IconButton, Stack } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { MdDelete } from "react-icons/md"
import { type CartItemSchema, type CartSchema, CartService } from "../client"
import type { ASPServiceForm } from "../client"
import ASPServiceFormDisplay from "./ASPServiceFormDisplay"
import PriceCalculator from "./PriceCalculator"

const Cart: React.FC = () => {
  const [cart, setCart] = useState<CartSchema | null>(null)

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const cartData = await CartService.getCart() // Fetch cart data
        setCart(cartData)
      } catch (error) {
        console.error("Failed to fetch cart data:", error)
      }
    }

    fetchCart()
  }, [])

  if (!cart || cart.items.length === 0) {
    return <div>Your cart is empty.</div>
  }

  return (
    <Stack>
      <>
        <h2>Your Cart</h2>
        {cart.items.map((item: CartItemSchema) => (
          <Box key={item.id}>
            <h3>
              {item.item_name}
              <span>
                <IconButton
                  aria-label="Delete item"
                  onClick={async () => {
                    await CartService.deleteCartItem({ id: item.id })
                    const cartData = await CartService.getCart()
                    setCart(cartData)
                  }}
                >
                  <MdDelete />
                </IconButton>
              </span>
            </h3>
            <Box>
              {item.item_name === "Attack Surface Profiler" &&
                item.configuration && (
                  <ASPServiceFormDisplay
                    serviceForm={item.configuration as ASPServiceForm}
                  />
                )}
              <b>
                Price with options: $
                {(Math.round(Number(item.price) * 100) / 100).toFixed(2)}
              </b>
            </Box>
          </Box>
        ))}
        <Box>
          <hr />
          <PriceCalculator cart={cart} />
        </Box>
      </>
    </Stack>
  )
}

export default Cart
